<template>
  <div
    id="m_quick_sidebar"
    class="m-quick-sidebar m-quick-sidebar--tabbed m-quick-sidebar--skin-light m-quick-sidebar--on"
  >
    <div class="m-quick-sidebar__content">
      <span class="m-quick-sidebar__close mt-2" @click="closeThis()"
        ><i class="fal fa-times-circle fa-lg"></i
      ></span>

      <ul
        id="m_quick_sidebar_tabs"
        class="nav nav-tabs m-tabs m-tabs-line m-tabs-line--brand"
        role="tablist"
      >
        <li class="nav-item m-tabs__item">
          <a
            class="nav-link m-tabs__link active"
            data-toggle="tab"
            href="#save_invoice"
            role="tab"
          >
            <h5><span class="far fa-pen-nib"></span> Editar Consumo</h5>
          </a>
        </li>
        <li class="nav-item m-tabs__item" v-if="invoiceId > 0">
          <a
            class="nav-link m-tabs__link"
            data-toggle="tab"
            href="#invoice_history"
            role="tab"
          >
            <h5><span class="far fa-history"></span> Histórico</h5>
          </a>
        </li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane active" id="save_invoice" role="tabpanel">
          <InvoiceSave :invoiceId="invoiceId" @savedInvoice="savedInvoice" />
        </div>
        <div class="tab-pane" id="invoice_history" role="tabpanel">
          <InvoiceHistory ref="invoiceHistory" :invoiceId="invoiceId" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InvoiceSave from '@/components/invoices/InvoiceSave';
import InvoiceHistory from '@/components/invoices/InvoiceHistory';

export default {
  name: 'InvoiceModal',
  components: { InvoiceSave, InvoiceHistory },
  methods: {
    closeThis() {
      this.$emit('updateList');
      this.$store.state.showInvoiceSave = null;
    },
    savedInvoice() {
      this.$refs.invoiceHistory.getDatas();
    },
  },
  computed: {
    invoiceId() {
      return this.$store.state.showInvoiceSave;
    },
  },
};
</script>
